import { createFileRoute } from "@tanstack/react-router";
import { Home } from "lucide-react";

import { OverviewScoreCards } from "@/components/brand-intel/overview/overview-score-cards";
import { AIInsights } from "@/components/brand-intel/overview/ai-insights";
import { ChannelPerformance } from "@/components/brand-intel/overview/channel-performance";
import { ExpensiveProblemBanner } from "@/components/brand-intel/overview/expensive-problem";
import { PageHeader } from "@/components/layout/heading";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/dashboard/intelligence/_layout/overview")({
  component: Overview,
});

export function Overview() {
  const session = useSession();
  const companyName = session.profile.company?.company_name;

  return (
    <section className="w-full space-y-6">
      <PageHeader title={
        <div className="flex items-center gap-2">
          <Home className="size-5 text-muted-foreground" strokeWidth={2.5} />
          Brand Intelligence Overview - {companyName ? `${companyName}` : ""}
        </div>
      } />
      <OverviewScoreCards />
      <div className="grid gap-6 lg:grid-cols-[3fr_2fr]">
        <AIInsights />
        <ChannelPerformance />
      </div>
      <ExpensiveProblemBanner />
    </section>
  );
}
